<template>
    <div>
        <v-row justify="space-between" v-if="!hideFecha">
            <v-col cols="12" md="8">
                <v-tabs v-model="tab">
                    <v-tab @click.stop>Datos personales</v-tab>
                    <v-tab @click.stop>Datos fiscales</v-tab>
                </v-tabs>
            </v-col>
            <slot name="header"></slot>
            <v-col cols="12" md="2">
                <v-text-field
                    readonly
                    :value="fecha_alta | format_date_time"
                    label="Fecha de alta"
                >
                </v-text-field>
            </v-col>
        </v-row>
        <v-expansion-panels :readonly="!hideFecha" v-model="panel" multiple>
            <CustomExpansionPanel
                :title="hideFecha ? 'Datos personales' : ''"
                :disabled="hideFecha"
            >
                <v-row
                    v-if="tab == 0"
                    :dense="!hideFecha"
                    :justify="hideFecha ? 'center' : 'start'"
                >
                    <v-col
                        :cols="base_col"
                        :lg="lg_col"
                        :md="md_col"
                        v-if="!hideFecha"
                    >
                        <v-text-field
                            :readonly="readonly"
                            outlined
                            :dense="!hideFecha"
                            :rules="required_val"
                            v-model="cliente.nombre_comercial"
                            label="Nombre"
                            required
                        ></v-text-field>
                    </v-col>

                    <v-col
                        :cols="base_col"
                        :lg="lg_col"
                        :md="md_col"
                        v-if="hideFecha"
                    >
                        <v-text-field
                            :readonly="readonly"
                            :dense="!hideFecha"
                            outlined
                            v-model="cliente.razon_social"
                            label="Nombre fiscal"
                        ></v-text-field>
                    </v-col>

                    <v-col
                        :cols="base_col"
                        :lg="lg_col"
                        :md="md_col"
                        v-if="hideFecha"
                    >
                        <v-text-field
                            :readonly="readonly"
                            :dense="!hideFecha"
                            outlined
                            v-model="cliente.cif"
                            label="CIF"
                        >
                        </v-text-field>
                    </v-col>

                    <v-col :cols="base_col" :lg="lg_col" :md="md_col">
                        <v-text-field
                            :readonly="readonly"
                            :dense="!hideFecha"
                            outlined
                            v-model="cliente.email"
                            type="text"
                            label="Email"
                            :rules="emailOrPhoneRule"
                        ></v-text-field>
                    </v-col>

                    <v-col :cols="base_col" :lg="lg_col" :md="md_col">
                        <v-text-field
                            :readonly="readonly"
                            :dense="!hideFecha"
                            outlined
                            v-model="cliente.telefono"
                            :rules="emailOrPhoneRule"
                            type="number"
                            label="Teléfono"
                        ></v-text-field>
                    </v-col>
                    <!-- <v-col :cols="base_col" :lg="lg_col" :md="md_col">
                        <v-textarea
                            :readonly="readonly"
                            :dense="!hideFecha"
                            rows="1"
                            auto-grow
                            outlined
                            :label="'Contactos adicionales'"
                            v-model="cliente.contacto_adicional"
                        >
                        </v-textarea>
                    </v-col> -->
                    <slot name="datos_personales"></slot>
                </v-row>

                <v-row :dense="!hideFecha" v-else>
                    <v-col :cols="base_col" :lg="lg_col" :md="md_col">
                        <v-text-field
                            :readonly="readonly"
                            :dense="!hideFecha"
                            outlined
                            v-model="cliente.razon_social"
                            label="Nombre fiscal"
                        ></v-text-field>
                    </v-col>

                    <v-col :cols="base_col" :lg="lg_col" :md="md_col">
                        <v-text-field
                            :readonly="readonly"
                            :dense="!hideFecha"
                            outlined
                            v-model="cliente.cif"
                            label="CIF"
                        >
                        </v-text-field>
                    </v-col>
                    <!-- <v-col :cols="base_col" :lg="lg_col" :md="md_col">
                        <div style="display: flex">
                            <v-text-field-comma
                                :readonly="readonly"
                                :dense="!hideFecha"
                                v-if="nueva == 0"
                                :outlined="true"
                                v-model="cliente.cuenta"
                                :rules="required_val"
                                type="number"
                                label="Cuenta contable asociada"
                                required
                            ></v-text-field-comma>
                            <v-autocomplete
                                :readonly="readonly"
                                :dense="!hideFecha"
                                v-else
                                outlined
                                label="Cuenta contable asociada"
                                name="cuenta"
                                v-model="cliente.cuenta"
                                :items="cuentas"
                                item-text="numero"
                                item-value="numero"
                            >
                                <template v-slot:selection="data">
                                    {{ data.item.numero }} -
                                    {{ data.item.partida }}
                                </template>
                                <template v-slot:item="data">
                                    <v-list-item-content>
                                        {{ data.item.numero }} -
                                        {{ data.item.partida }}
                                    </v-list-item-content>
                                </template>
                            </v-autocomplete>
                            <v-btn-toggle
                                :readonly="readonly"
                                :dense="!hideFecha"
                                color="primary"
                                shaped
                                v-model="nueva"
                                background-color="white"
                            >
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            :dense="!hideFecha"
                                            text
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            <v-icon>mdi-file-account</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Nueva cuenta</span>
                                </v-tooltip>

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            :dense="!hideFecha"
                                            text
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            <v-icon
                                                >mdi-file-search-outline</v-icon
                                            >
                                        </v-btn>
                                    </template>
                                    <span>Seleccionar cuenta</span>
                                </v-tooltip>
                            </v-btn-toggle>
                        </div>
                    </v-col> -->
                </v-row>
            </CustomExpansionPanel>

            <template v-if="tab == 1 || hideFecha">
                <CustomExpansionPanel title="Dirección" :disabled="hideFecha">
                    <v-row
                        :dense="!hideFecha"
                        :justify="hideFecha ? 'center' : 'start'"
                        :style="
                            hideFecha
                                ? `padding-left:10rem;padding-right:10rem`
                                : ''
                        "
                    >
                        <v-col :cols="base_col" :lg="lg_col" :md="md_col">
                            <v-text-field
                                :readonly="readonly"
                                :dense="!hideFecha"
                                outlined
                                v-model="cliente.direccion.direccion"
                                label="Dirección"
                                required
                            ></v-text-field>
                        </v-col>

                        <v-col :cols="base_col" :lg="lg_col" :md="md_col">
                            <v-text-field
                                :readonly="readonly"
                                outlined
                                :dense="!hideFecha"
                                v-model="cliente.direccion.codigo_postal"
                                type="number"
                                label="Código postal"
                                required
                            ></v-text-field>
                        </v-col>

                        <v-col :cols="base_col" :lg="lg_col" :md="md_col">
                            <v-text-field
                                :readonly="readonly"
                                :dense="!hideFecha"
                                outlined
                                v-model="cliente.direccion.ciudad"
                                type="text"
                                label="Población"
                                required
                            ></v-text-field>
                        </v-col>

                        <v-col :cols="base_col" :lg="lg_col" :md="md_col">
                            <v-autocomplete
                                :readonly="readonly"
                                :dense="!hideFecha"
                                outlined
                                v-model="cliente.direccion.id_provincia"
                                :items="provincias"
                                item-text="nombre"
                                item-value="id"
                                label="Provincia"
                            >
                            </v-autocomplete>
                        </v-col>

                        <v-col :cols="base_col" :lg="lg_col" :md="md_col">
                            <v-checkbox
                                :readonly="readonly"
                                v-model="cliente.misma_direccion"
                                label="Usar la misma dirección para la instalación"
                            ></v-checkbox>
                        </v-col>
                    </v-row>
                </CustomExpansionPanel>
                <CustomExpansionPanel
                    title="Dirección de instalación"
                    :disabled="hideFecha"
                    v-if="
                        cliente.misma_direccion == 0 ||
                        cliente.misma_direccion == false
                    "
                >
                    <v-row
                        :dense="!hideFecha"
                        :justify="hideFecha ? 'center' : 'start'"
                        :style="
                            hideFecha
                                ? `padding-left:10rem;padding-right:10rem`
                                : ''
                        "
                    >
                        <v-col :cols="base_col" :lg="lg_col" :md="md_col">
                            <v-text-field
                                :readonly="readonly"
                                :dense="!hideFecha"
                                outlined
                                v-model="
                                    cliente.direccion_instalacion.direccion
                                "
                                :rules="required_val"
                                label="Dirección"
                                required
                            ></v-text-field>
                        </v-col>

                        <v-col :cols="base_col" :lg="lg_col" :md="md_col">
                            <v-text-field
                                :readonly="readonly"
                                :dense="!hideFecha"
                                outlined
                                v-model="
                                    cliente.direccion_instalacion.codigo_postal
                                "
                                :rules="required_val"
                                type="number"
                                label="Código postal"
                                required
                            ></v-text-field>
                        </v-col>

                        <v-col :cols="base_col" :lg="lg_col" :md="md_col">
                            <v-text-field
                                :readonly="readonly"
                                :dense="!hideFecha"
                                outlined
                                v-model="cliente.direccion_instalacion.ciudad"
                                :rules="required_val"
                                type="text"
                                label="Población"
                                required
                            ></v-text-field>
                        </v-col>

                        <v-col :cols="base_col" :lg="lg_col" :md="md_col">
                            <v-autocomplete
                                :readonly="readonly"
                                :dense="!hideFecha"
                                outlined
                                v-model="
                                    cliente.direccion_instalacion.id_provincia
                                "
                                :rules="required_val"
                                :items="provincias"
                                item-text="nombre"
                                item-value="id"
                                label="Provincia"
                            >
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                </CustomExpansionPanel>
            </template>
        </v-expansion-panels>

        <v-row
            :justify="hideFecha ? 'center' : 'start'"
            :style="hideFecha ? `padding-left:10rem;padding-right:10rem` : ''"
        >
            <v-col :cols="base_col" :md="md_card_col">
                <multiple-select
                    :headers="headers_contacto"
                    title="Contacto"
                    :elementos="cliente.contactos"
                    show="nombre"
                    @create="createContacto"
                    @delete="deleteContacto"
                    @getEstado="updateContactoS"
                    @update="updateContacto"
                >
                    <v-row>
                        <v-col cols="12" md="6" class="pr-4 pr-md-5">
                            <TipoContactoSelect
                                v-model="contacto.tipo"
                                :estados="tipoContactos"
                                :disabled="readonly"
                                :rules="required_val"
                                @create="onCreateTipoContacto"
                                @update="onUpdateTipoContacto"
                                @delete="onDeleteTipoContacto"
                            />
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                outlined
                                v-model="contacto.nombre"
                                label="Nombre"
                                :rules="required_val"
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field
                                outlined
                                v-model="contacto.telefono"
                                label="Teléfono"
                                type="number"
                                :rules="required_val"
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                outlined
                                v-model="contacto.email"
                                label="Email"
                                :rules="required_val"
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                </multiple-select>
            </v-col>

            <slot></slot>

            <template v-if="!readonly">
                <v-col
                    :cols="base_col"
                    :md="md_card_col"
                    v-if="rol != 4 && rol != 5 && !hideFecha && tab == 0"
                >
                    <multiple-select
                        :headers="headers_agentes"
                        title="Agentes"
                        :elementos="cliente.agentes"
                        show="nombre"
                        @create="createAgente"
                        @delete="deleteAgentes"
                        @getEstado="updateAgentesS"
                        @update="updateAgentes"
                    >
                        <v-autocomplete
                            outlined
                            v-model="agente.id"
                            :items="agentes"
                            item-text="nombre"
                            item-value="id"
                            label="Agente"
                            :rules="required_val"
                        >
                        </v-autocomplete>
                    </multiple-select>
                </v-col>
                <v-col cols="12" md="6" v-if="!hideFecha && tab == 1">
                    <multiple-select
                        :headers="[
                            { text: 'Método', value: 'metodo.nombre' },
                            {
                                text: 'Vencimiento (días)',
                                value: 'vencimiento',
                            },

                            { text: 'Acciones', value: 'action' },
                        ]"
                        title="Métodos de pago"
                        :elementos="cliente.metodos_pago"
                        show="nombre"
                        @create="
                            cliente.metodos_pago.push({
                                id_metodo: metodo_pago.metodo.id,
                                metodo: metodo_pago.metodo,
                                vencimiento: metodo_pago.vencimiento,
                            });
                            metodos_pago = {
                                metodo: {},
                                vencimiento: null,
                            };
                        "
                        @delete="
                            (index) => {
                                cliente.metodos_pago.splice(index, 1);
                            }
                        "
                        @getEstado="OpenEditMetodos"
                        @update="
                            () => {
                                cliente.metodos_pago[index] = metodo_pago;
                                metodo_pago = {
                                    metodo: {},
                                    vencimiento: null,
                                };
                            }
                        "
                    >
                        <v-autocomplete
                            outlined
                            v-model="metodo_pago.metodo"
                            :items="metodos_pago"
                            item-text="nombre"
                            return-object
                            label="Método"
                            :rules="required_val"
                        >
                        </v-autocomplete>
                        <v-autocomplete
                            outlined
                            v-model="metodo_pago.vencimiento"
                            :items="[15, 30, 60]"
                            label="Vencimiento"
                            :rules="required_val"
                        >
                        </v-autocomplete>
                    </multiple-select>
                </v-col>
            </template>
        </v-row>
    </div>
</template>
<script>
import CustomExpansionPanel from "./CustomExpansionPanel.vue";
import TipoContactoSelect from "../../../components/general/TipoContactoSelect.vue";
export default {
    props: ["value", "agentes", "hideFecha", "readonly"],
    components: {
        CustomExpansionPanel,
        TipoContactoSelect,
    },
    data() {
        return {
            tab: 0,
            metodo_pago: {
                id: null,
                metodo: { nombre: "" },
                vencimiento: null,
            },
            cuentas: [],
            selectedIndex: null,
            panel: [0],
            tipoContactos: [
                { id: 0, nombre: "Comercial" },
                { id: 1, nombre: "Facturación" },
            ],
            nextTipoId: 2,

            headers_agentes: [
                { text: "Agente", value: "agente.nombre", sortable: false },
                //{ text: "Nomina", value: "agente.nomina_bruto", sortable: false },
                { text: "DNI", value: "agente.dni", sortable: false },
                {
                    text: "Fecha de alta",
                    value: "agente.fecha_alta",
                    sortable: false,
                },
                { text: "Acciones", value: "action", sortable: false },
            ],
            headers_productos: [
                { text: "Producto", value: "producto.titulo", sortable: false },

                { text: "Acciones", value: "action", sortable: false },
            ],
            headers_contacto: [
                { text: "Tipo", value: "tipo", sortable: false },
                { text: "Nombre", value: "nombre", sortable: false },
                { text: "Teléfono", value: "telefono", sortable: false },
                { text: "Email", value: "email", sortable: false },

                { text: "Acciones", value: "action", sortable: false },
            ],
            cliente: {
                direccion: {},
                direccion_instalacion: {},
            },
            contacto: {},
            agente: {},
            nueva: 0,
            emailRules: [
                (v) => !!v || "El campo es requerido",
                (v) =>
                    !v ||
                    /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                    "El e-mail debe ser válido",
            ],
            required_val: [(v) => !!v || "El campo es requerido"],
            emailOrPhoneRule: [
                (v) => {
                    if (this.cliente.email || this.cliente.telefono) {
                        return true;
                    }
                    return !!v || "El email o el teléfono es requerido";
                },
            ],
        };
    },
    watch: {
        value(val) {
            this.cliente = val ?? {};
            if (this.cliente.direccion == null) {
                this.cliente.direccion = {};
            }
            if (this.cliente.direccion_instalacion == null) {
                this.cliente.direccion_instalacion = {};
            }
            this.incorporarTiposContactoExistentes();
        },
        cliente(val) {
            this.$emit("input", val);
        },
    },
    created() {
        this.getCuentas();

        if (this.value != null) {
            this.cliente = this.value;
            if (this.cliente.direccion == null) {
                this.cliente.direccion = {};
            }
            if (this.cliente.direccion_instalacion == null) {
                this.cliente.direccion_instalacion = {};
            }
            this.incorporarTiposContactoExistentes();
        }
    },
    methods: {
        // Añade a tipoContactos los tipos que ya tengan los contactos del cliente (p. ej. al editar)
        incorporarTiposContactoExistentes() {
            if (!this.cliente.contactos || !Array.isArray(this.cliente.contactos)) return;
            this.cliente.contactos.forEach((c) => {
                const nombre = c.tipo && typeof c.tipo === "string" ? c.tipo.trim() : "";
                if (!nombre) return;
                const existe = this.tipoContactos.some((t) => t.nombre === nombre);
                if (!existe) {
                    this.tipoContactos.push({ id: this.nextTipoId++, nombre });
                }
            });
            this.tipoContactos.sort((a, b) => (a.nombre || "").localeCompare(b.nombre || ""));
        },
        onCreateTipoContacto(nombre) {
            const n = (nombre || "").trim();
            if (!n || this.tipoContactos.some((t) => t.nombre === n)) return;
            this.tipoContactos.push({ id: this.nextTipoId++, nombre: n });
            this.tipoContactos.sort((a, b) => (a.nombre || "").localeCompare(b.nombre || ""));
            // Asignar el nuevo tipo al contacto actual para que quede seleccionado en el select
            if (this.contacto && typeof this.contacto === "object") {
                this.$set(this.contacto, "tipo", n);
            }
        },
        onUpdateTipoContacto(item) {
            const idx = this.tipoContactos.findIndex((t) => t.id === item.id);
            if (idx === -1) return;
            const antiguo = this.tipoContactos[idx].nombre;
            const nuevo = (item.nombre || "").trim();
            if (!nuevo || (nuevo !== antiguo && this.tipoContactos.some((t) => t.nombre === nuevo))) return;
            this.tipoContactos[idx].nombre = nuevo;
            this.tipoContactos.sort((a, b) => (a.nombre || "").localeCompare(b.nombre || ""));
            if (this.cliente.contactos && Array.isArray(this.cliente.contactos)) {
                this.cliente.contactos.forEach((c) => {
                    if (c.tipo === antiguo) c.tipo = nuevo;
                });
            }
        },
        onDeleteTipoContacto(id) {
            const idx = this.tipoContactos.findIndex((t) => t.id === id);
            if (idx === -1) return;
            const nombreBorrado = this.tipoContactos[idx].nombre;
            this.tipoContactos.splice(idx, 1);
            if (this.cliente.contactos && Array.isArray(this.cliente.contactos)) {
                this.cliente.contactos.forEach((c) => {
                    if (c.tipo === nombreBorrado) c.tipo = "";
                });
            }
            if (this.contacto && this.contacto.tipo === nombreBorrado) this.contacto.tipo = "";
        },
        getCuentas() {
            let prefix = 430;
            axios.get(`api/get-cuentas/${prefix}`).then(
                (res) => {
                    this.cuentas = res.data.success;

                    let numero = 0;
                    this.cuentas.forEach((element) => {
                        if (numero < element.numero) {
                            numero = element.numero;
                        }
                    });

                    this.cliente.cuenta = parseInt(numero) + 1;
                },
                (res) => {}
            );
        },
        OpenEditMetodos(index) {
            if (index != null) {
                this.metodo_pago = JSON.parse(
                    JSON.stringify(this.cliente.metodos_pago[index])
                );
                this.index = index;
            }
        },
        updateAgentesS(index) {
            this.index = index;
        },
        deleteAgentes(indexo) {
            if (this.cliente.agentes_eliminados == null) {
                this.cliente.agentes_eliminados = [];
            }
            if (this.cliente.agentes[indexo].id != null) {
                this.cliente.agentes_eliminados.push(
                    this.cliente.agentes[indexo].id
                );
            }
            //console.log(this.cliente);
            this.cliente.agentes.splice(indexo, 1);
        },
        createAgente() {
            //console.log(this.agente.id);
            this.getIndexOfId(this.agente.id);
            this.cliente.agentes.push({
                id: null,
                id_agente: this.agente.id,
                agente: JSON.parse(JSON.stringify(this.agentes[this.index])),
            });
            //console.log(this.cliente.agentes);
            this.agente = JSON.parse(JSON.stringify(this.agenteSelected));
        },
        getIndexOfId(id) {
            for (let i = 0; i < this.agentes.length; i++) {
                if (this.agentes[i].id == id) {
                    this.index = i;
                    break;
                }
            }
        },
        updateAgentes() {
            for (let i = 0; i < this.agentes.length; i++) {
                //console.log(`${this.agentes[i].id}`);

                if (this.agentes[i].id == this.agente.id) {
                    this.cliente.agentes[this.index].id_agente =
                        this.agentes[i].id;
                    this.cliente.agentes[this.index].agente = JSON.parse(
                        JSON.stringify(this.agentes[i])
                    );

                    break;
                }
            }
        },
        updateContactoS(index) {
            //console.log(index);
            this.contacto = JSON.parse(
                JSON.stringify(this.cliente.contactos[index])
            );
            this.index = index;
        },
        deleteContacto(indexo) {
            //console.log(indexo);
            if (this.cliente.contactos_eliminados == null) {
                this.cliente.contactos_eliminados = [];
            }
            if (this.cliente.contactos[indexo].id != null) {
                this.cliente.contactos_eliminados.push(
                    this.cliente.contactos[indexo].id
                );
            }
            this.cliente.contactos.splice(indexo, 1);
            //console.log(this.cliente);
        },
        createContacto() {
            this.cliente.contactos.push(
                JSON.parse(JSON.stringify(this.contacto))
            );
            //console.log(this.cliente.contactos);
        },

        updateContacto() {
            //console.log("prueba");
            this.cliente.contactos[this.index] = JSON.parse(
                JSON.stringify(this.contacto)
            );
        },
    },
    computed: {
        fecha_alta() {
            if (this.cliente.created_at != null) {
                return this.cliente.created_at;
            } else if (this.cliente.fecha_alta != null) {
                return this.cliente.fecha_alta;
            } else {
                const now = new Date();
                return now.toISOString();
            }
        },
        base_col() {
            return 12;
        },
        lg_col() {
            return this.hideFecha ? 7 : 3;
        },
        md_col() {
            return this.hideFecha ? 7 : 4;
        },
        md_card_col() {
            return this.hideFecha ? 7 : 6;
        },
        metodos_pago() {
            return this.$store.getters.metodos_pago;
        },
        rol() {
            return localStorage.getItem("role");
        },
        provincias() {
            return this.$store.getters.getprovincias;
        },
    },
};
</script>
